import React, { useState, useEffect } from 'react';
import { handleFetchPlans } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  Paper,
  Grid,
} from '@mui/material';
import { styled } from '@mui/system';
import PlanCard from '../../common/components/PlanCard';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

export default function PickPlanForm(props) {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [availablePlans, setAvailablePlans] = useState([]);

  useEffect(() => {
    setLoading(true);
    handleFetchPlans()
      .then((res) => {
        if (res) {
          res.sort(function (a, b) {
            return a.DisplayOrder - b.DisplayOrder;
          });
          setAvailablePlans(res);
        } else {
          setAvailablePlans({});
        }
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(err.message);
        setAvailablePlans({});
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Stack alignItems='center' justifyContent='center'>
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : availablePlans && availablePlans.length > 0 ? (
        <Item>
          <Grid
            container
            direction='row'
            justifyContent='center'
            alignItems='flex-start'
            sx={{
              width: '100%',
              height: '100%',
              borderRadius: '0',
            }}
            rowSpacing={1}
          >
            {availablePlans.map((plan) => (
              <Grid item key={plan.PlanID}>
                <PlanCard
                  id={plan.PlanID}
                  code={plan.PlanCode}
                  name={plan.PlanName}
                  description={plan.PlanDescription}
                  currencyCode={plan.PlanCurrencyCode}
                  unitCost={plan.PlanUnitCost}
                  interval={plan.PlanInterval}
                  intervalLength={plan.PlanIntervalLength}
                  freeTrialInterval={plan.FreeTrialInterval}
                  freeTrialLength={plan.FreeTrialLength}
                  handleSelect={() => {
                    props.setSelecetedPlan({
                      PlanID: plan.PlanID,
                      PlanCode: plan.PlanCode,
                      PlanName: plan.PlanName,
                      PlanDescription: plan.PlanDescription,
                      PlanCurrencyCode: plan.PlanCurrencyCode,
                      PlanUnitCost: plan.PlanUnitCost,
                      PlanInterval: plan.PlanInterval,
                      PlanIntervalLength: plan.PlanIntervalLength,
                      FreeTrialInterval: plan.FreeTrialInterval,
                      FreeTrialLength: plan.FreeTrialLength,
                    });
                    props.successAction();
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Item>
      ) : (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <Typography>No available plans were found</Typography>
          </Grid>
        </Grid>
      )}
      {errorMessage && (
        <Item>
          <Typography sx={{ color: 'error.main' }}>{errorMessage}</Typography>
        </Item>
      )}
    </Stack>
  );
}
